import React, {useState} from 'react';
import "./onboard-language-select-style.scss";
import OnboardButton from "../onboard-button-component/OnboardButton";
import {useTranslation} from "react-i18next";
import {ReactComponent as FlagTR} from './images/tr.svg';
import {ReactComponent as FlagEN} from './images/en.svg';
import {ReactComponent as FlagFR} from './images/fr.svg';
import {ReactComponent as FlagES} from './images/es.svg';
import {ReactComponent as FlagRU} from './images/ru.svg';
import {ReactComponent as FlagDE} from './images/de.svg';
import {ReactComponent as FlagZH} from './images/zh.svg';
import {ReactComponent as FlagIT} from './images/it.svg';
import {ReactComponent as FlagJA} from './images/ja.svg';
import {ReactComponent as FlagKO} from './images/ko.svg';
import {ReactComponent as FlagPT} from './images/pt.svg';
import {ReactComponent as FlagLT} from './images/lt.svg';
import {ReactComponent as FlagAR} from './images/ar.svg';
import {useSetRecoilState} from "recoil";
import {loadingAtom} from "../../../store/LoadingStore";

const OnboardLanguageSelect = (props) => {
    const {t, i18n} = useTranslation();
    const setLoading = useSetRecoilState(loadingAtom);
    const {visible, onClose} = props;
    const [select, setSelect] = useState(i18n?.language);

    const getSelect = (lang) => {
        if (select.indexOf(lang) >= 0) return "active";
        return "";
    }

    const handleLanguage = (lang) => {
        setSelect(lang);
    }

    const handleOk = () => {
        setLoading(true);
        i18n.changeLanguage(select, function () {
            setLoading(false);
            onClose();
        })
    }

    return (
        visible && (
            <div>
                <div className="onboard-dialog-opacity"></div>
                <div className="onboard-language-select">
                    <div className="onboard-language-select-root">
                        <p>{t('header_service.select_language')}</p>
                        <div className="onboard-language-select-bars">
                            <div onClick={() => handleLanguage("tr")}
                                 className={"onboard-language-select-bar " + getSelect("tr")}>
                                <FlagTR/>
                                <p>Türkçe</p>
                            </div>
                            <div onClick={() => handleLanguage("en")}
                                 className={"onboard-language-select-bar " + getSelect("en")}>
                                <FlagEN/>
                                <p>English</p>
                            </div>
                            <div onClick={() => handleLanguage("ru")}
                                 className={"onboard-language-select-bar " + getSelect("ru")}>
                                <FlagRU/>
                                <p>Русский</p>
                            </div>
                            <div onClick={() => handleLanguage("fr")}
                                 className={"onboard-language-select-bar " + getSelect("fr")}>
                                <FlagFR/>
                                <p>Français</p>
                            </div>
                            <div onClick={() => handleLanguage("de")}
                                 className={"onboard-language-select-bar " + getSelect("de")}>
                                <FlagDE/>
                                <p>Deutsch</p>
                            </div>
                            <div onClick={() => handleLanguage("es")}
                                 className={"onboard-language-select-bar " + getSelect("es")}>
                                <FlagES/>
                                <p>Español</p>
                            </div>
                            <div onClick={() => handleLanguage("zh")}
                                 className={"onboard-language-select-bar " + getSelect("zh")}>
                                <FlagZH/>
                                <p>中文</p>
                            </div>
                            <div onClick={() => handleLanguage("it")}
                                 className={"onboard-language-select-bar " + getSelect("it")}>
                                <FlagIT/>
                                <p>Italiano</p>
                            </div>
                            <div onClick={() => handleLanguage("ja")}
                                 className={"onboard-language-select-bar " + getSelect("ja")}>
                                <FlagJA/>
                                <p>日本語</p>
                            </div>
                            <div onClick={() => handleLanguage("ko")}
                                 className={"onboard-language-select-bar " + getSelect("ko")}>
                                <FlagKO/>
                                <p>한국어</p>
                            </div>
                            <div onClick={() => handleLanguage("pt")}
                                 className={"onboard-language-select-bar " + getSelect("pt")}>
                                <FlagPT/>
                                <p>Português</p>
                            </div>
                            <div onClick={() => handleLanguage("lt")}
                                 className={"onboard-language-select-bar " + getSelect("lt")}>
                                <FlagLT/>
                                <p>Lietuvių</p>
                            </div>
                            {/*<div onClick={() => handleLanguage("ar")}*/}
                            {/*     className={"onboard-language-select-bar " + getSelect("ar")}>*/}
                            {/*    <FlagAR/>*/}
                            {/*    <p>العربية</p>*/}
                            {/*</div>*/}
                        </div>
                        <OnboardButton label={t('approve')} onClick={() => handleOk()}/>
                    </div>
                </div>
            </div>
        )

    )
};

export default OnboardLanguageSelect;
